import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateInvoicePaymentController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import InvoicePaymentService from "../../Controller/InvoicePaymentController";
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
function CreateInvoicePayment({ modalInstance, currentInvoicePayment, onClose, onSuccess, InvoiceID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const [formData, setFormData] = useState({
        ID: 0, dt_Created: '', vc_Description: "", FK_Invoice_ID: InvoiceID
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [InvoicePaymentMethodList, setInvoicePaymentMethod] = useState([]);
    const fetchInvoicePayment = async () => {
        try {

            const data = await InvoicePaymentService.GetAllPaymentMethod();
            setInvoicePaymentMethod(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    useEffect(() => {
        fetchInvoicePayment();
        if (currentInvoicePayment) {

            const formattedDate = new Date(currentInvoicePayment.dt_PaymentDate).toISOString().split('T')[0];
            setFormData({
                ...formData,
                dt_PaymentDate: formattedDate,
                mon_Amount: currentInvoicePayment.mon_Amount,
                snt_PaymentType: currentInvoicePayment.snt_PaymentType,
                Reference: currentInvoicePayment.Reference,
                FK_Invoice_ID: currentInvoicePayment.FK_Invoice_ID,
            });
        } else {
            setFormData({
                ...formData,
                FK_Invoice_ID: InvoiceID, dt_PaymentDate: '', mon_Amount: "", snt_PaymentType: 0,
                Reference: ""
            });
        }
    }, [currentInvoicePayment]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();

        if (currentInvoicePayment) {
            formData.ID = currentInvoicePayment.PK_InvoicePayment_ID;
        } else {
            formData.ID = 0;
        }
        formData.FK_Invoice_ID = InvoiceID;
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess();

        }, () => {
            onSuccess();

        });
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerHistoryModal show d-block" id="customerHistoryModal" tabIndex="-1" aria-labelledby="customerHistoryModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentInvoicePayment ? "Edit Payment" : "Add Payment"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{width:"13%"}}><label htmlFor="dt_PaymentDate" style={{ float: "right" }}>Date <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td style={{width:"37%"}}>
                                                        <input type="date" className="form-control" name="dt_PaymentDate" value={formData.dt_PaymentDate} onChange={handleFieldChange} />
                                                        {errors.dt_PaymentDate && <div style={{ color: 'red' }}>{errors.dt_PaymentDate}</div>}
                                                    </td>
                                                    <td style={{width:"13%"}}><label htmlFor="mon_Amount" style={{ float: "right" }}>Amount <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td style={{width:"37%"}}>
                                                        <input type="text" className="form-control" name="mon_Amount" value={formData.mon_Amount} onChange={handleFieldChange} />
                                                        {errors.mon_Amount && <div style={{ color: 'red' }}>{errors.mon_Amount}</div>}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><label htmlFor="snt_PaymentType" style={{ float: "right" }}>Payment Type <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td>
                                                        <select name="snt_PaymentType" className='form-control' value={formData.snt_PaymentType} onChange={handleFieldChange}>
                                                            <option value="0"> Select Type</option>
                                                            {InvoicePaymentMethodList.map((type) => (
                                                                <option key={type.PK_PaymentMethod_ID} value={type.PK_PaymentMethod_ID}>
                                                                    {type.vc_Name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.snt_PaymentType && <div style={{ color: 'red' }}>{errors.snt_PaymentType}</div>}
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td><label htmlFor="Reference" style={{ float: "right" }}>Reference <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td colSpan={3}>
                                                        <input type="text" className="form-control" name="Reference" value={formData.Reference} onChange={handleFieldChange} />
                                                        {errors.Reference && <div style={{ color: 'red' }}>{errors.Reference}</div>}
                                                    </td>

                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  {currentInvoicePayment ? " Update" : " Save"}
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateInvoicePayment;
